<template>
  <div class="social-container">
    <div class="social">
       <div class="banner">
          <div class="banner_img">
            <div class="enter-button min-container" @click="scrollSocialToJob">
              <img :src="`${imageRoot}/social/ENTERGAME_button.png`" alt="" srcset="">
            </div>
          </div>
       </div>
    </div>
    <div class="future-content min-containerPerc">
      <el-row>
        <el-col class="title" :span="20">
          <p>Explore Your Future</p>
        </el-col>
      </el-row>
      <div class="rotate-image">
        <rotate-swiper></rotate-swiper>
      </div>
    </div>
    <div class="position-content min-containerPerc">
      <el-row>
        <el-col class="title" :span="20">
          <p>Open Positions</p>
        </el-col>
      </el-row>
      <el-row class="job-container">
        <el-col :span="24">
          <el-row class="select-job">
            <el-col
              v-for="items in jobClass"
              :key="items.index"
              :class='{active:items.active}'
              :span="4"
            >
              <p @click.prevent="handleJobSelect(items.index)">{{ items.content }}</p>
            </el-col>
          </el-row>
        </el-col>
        <el-col class="job-table game" v-if="showTable === 'market'" :span="23">
          <job-table :table-data="tableDatas.market" ></job-table>
        </el-col>
        <el-col class="job-table market" v-if="showTable === 'sales'" :span="23">
          <job-table :table-data="tableDatas.sales" ></job-table>
        </el-col>
        <el-col class="job-table corporte" v-if="showTable === 'support'" :span="23">
          <job-table :table-data="tableDatas.support"></job-table>
        </el-col>
      </el-row>
    </div>
    <div class="min-containerPerc" :style="{height:'55px', marginTop:'2%'}">
      <a class="social-top-button" @click.prevent="scrollSocialToTop">
        <img :src="`${imageRoot}/common/top_button.png`">
      </a>
    </div>
  </div>
</template>

<script>
import RotateSwiper from '@/components/SocialComponent/RotateSwiper2D.vue'
import JobTable from '@/components/SocialComponent/JobPosition.vue'
import { jobMaps } from '@/utils/jobMap.js'

export default {
  components: {
    RotateSwiper,
    JobTable
  },
  data: () => ({
    jobIds: [],
    jobMapEx: {},
    jobClass: [
      { index: 'market', active: true, content: 'Marketing' },
      { index: 'sales', active: false, content: 'Sales' },
      { index: 'support', active: false, content: 'Support' }
    ],
    tableDatas: {},
    scrollTop: 0,
    imageRoot: process.env.VUE_APP_IMAGE_PATH
  }),
  computed: {
    showTable: function () {
      return this.jobClass.filter((el) => el.active === true)[0].index
    }
  },
  methods: {
    scrollSocialToJob () {
      let offsetTopJob = document.querySelector('.position-content').offsetTop
      window.scrollTo(0, offsetTopJob)
    },
    scrollSocialToTop () {
      window.scrollTo({ 'behavior': 'smooth', 'top': 0 })
    },
    handleJobSelect (e) {
      this.jobClass.map((el) => {
        if (el.active && el.index !== e) {
          el.active = false
        } else if (el.index === e) {
          el.active = true
        }
      })
    },
    isShowTable (table) {
      return this.jobClass.filter((el) => el.index === table)[0].acitve
    },
    getAllJobIds () {
      return this.$axios.get('/admin/jobKiwi', { params: { from: 3 } }).then(res => {
        this.jobIds = res.data.data.map(el => el.id)
      })
    },
    makeJobMapEx () {
      Object.entries(jobMaps).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
          this.jobMapEx[value] = key
        } else {
          value.forEach((el) => {
            this.jobMapEx[el] = key
          })
        }
      })
    },
    jobClassifier (jobs) {
      jobs.forEach(job => {
        let jobClass = this.jobMapEx[job.type_id]
        if (this.tableDatas.hasOwnProperty(jobClass)) {
          this.tableDatas[jobClass].push(job)
        } else {
          this.$set(this.tableDatas, jobClass, [job])
        }
      })
    }
  },
  created () {
    this.makeJobMapEx()
    this.getAllJobIds().then(() => {
      this.$axios.all(this.jobIds.map(id => {
        return this.$axios.get('/admin/jobKiwi/jobPosition', { params: { jobType: id } })
      })).then(this.$axios.spread((...res) => {
        res.forEach(jobItems => {
          this.jobClassifier(jobItems.data.data)
        })
      }))
    })
  },
  beforeRouteLeave (to, from, next) {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      document.documentElement.scrollTop = vm.scrollTop
      document.body.scrollTop = vm.scrollTop
    })
  }
}
</script>
<style lang="scss" scoped>
.social-top-button{
  @include topButton(93%);
  top:10px;
}
</style>
<style lang="scss" scoped>
  .job-container{
    margin-top:50px;
    position: relative;
    left:47px;
    margin-bottom: 100px;
    .job-table{
      position: relative;
      top:30px;
      //height:600px;
    }
  }
  .select-job{
    position: relative;
    top:20px;
    left:0;
    background-image:url('#{$imageRoot}/social/position_nor.png');
    background-repeat: no-repeat;
    background-size: initial;
    height:70px;
    cursor: pointer;
    .el-col{
      padding:0;
      margin: 0;
      line-height: 58px;
      text-align: center;
      width: 260px;
      font-size: 16px;
      color:#636363;
      p{
        width:100%;
        height:100%;
        cursor: pointer;
        padding:0;
        margin:0
      }
    }
    .el-col.active{
      background-image: url('#{$imageRoot}/social/position_select.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color:#ffffff
    }
  }
</style>
<style lang="scss" scoped>
  .rotate-image{
    padding-bottom: 10%;
    position: relative;
    left: 26px;
    width: 93.22%;
    margin:0 auto;
    margin-top: 6%;
  }
</style>
<style lang="scss" scoped>
  .min-containerPerc{
   @include minContainerPerc;
  }
  .min-container{
    @include minContainer;
  }

  .future-content,
  .position-content{
    .title{
      @include normalTitle('#{$imageRoot}/home/title_dot.png',45px, 45px, 46px, 75px, 10, 76.8px);
    }
  }
  .salary{
    padding-top: 3%;
    @include backgroundImage(block, 100%, none, "#{$imageRoot}/social/BG.png", center top, no-repeat, auto 100%, none);
    padding-bottom: 5%;
    .title-content{
      margin: 1% auto;
    }
    .title{
      @include normalTitle('#{$imageRoot}/home/title_dot.png',45px, 45px, 46px, 28px, 10, none);
      p{
        left:75px
      }
    }
  }
  .future-content{
    .title{
      p{
        left:85px
      }
    }
  }
  .position-content{
    height: fit-content;
    min-height: 600px;
    @extend .future-content;
  }
</style>

<style lang='scss' scoped>
  .social-container{
    margin-bottom:70px;
  }
  .social {
    position: relative;
    padding: 0px 0px 0px 0px;
    .banner {
      position: relative;
      height: 743px;
      .banner_img {
        @include backgroundImage(block, 100%, 743px, "#{$imageRoot}/social/topbanner.png", center top, no-repeat, auto 100%, none);
        img{
          position: relative;
          top:425px;
          left:41%;
          cursor: pointer;
          @include hoverAnimation(1.05);
          width:19%
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
.comprehensive-detail{
    display: flex;
    width:1100px;
    margin:0 auto;
    justify-content: flex-end;
    margin-top: 8%;
    margin-left: 3%;

    .bubble{
        padding-right: 30px;
    }
}

.detail-content{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: space-between;
  height: 610px;
  width: 900px;
  >div{
      width:300px
  }
  .icon-title{
      display: flex;
  }
  li{
    list-style: none;

    p{
        color:#636363;
        font-family: $fontFmaily;
    }

    &::before{
        content:'\2022';
        position: absolute;
        margin-left:-20px;
        color:black;
    }
  }
}

.icon-title{
   border-bottom: 1px solid #151515;
   padding-bottom: 10px;
   img{
       width:29.2px;
       height:30px
   }
   p{
       line-height: 1px;
       padding-left:10px;
       font-family: $fontFmaily;
       font-size: 18px;
       margin-top: 14px;
   }
}

@media only screen and (max-width: 1460px){
  .comprehensive-detail{
      display: flex;
      width:130%;
      justify-content: flex-start;
      margin-top: 8%;
      margin-left: -16%;

      .bubble{
          padding-right: 30px;
      }
  }
}
</style>

<style lang="scss" scoped>
@media only screen and (max-width: 1460px) {
  .social{
    .banner{
      height: 550px;
      .banner_img{
        height: 550px;
        img{
          position: relative;
          top:300px;
          left:41%;
          cursor: pointer;
          @include hoverAnimation(1.05);
          width:19%
        }
      }
    }
  }
}
</style>
